import axios from "axios";
import { auth } from "../firebase/firebaseApp";

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

export const httpClient = axios.create({
  baseURL: apiBaseUrl,
});

httpClient.interceptors.request.use(async (config) => {
  // If `config.url` starts with `/`, Axios treats it as an absolute path and
  // drops any path part of `baseURL` (e.g. `/api`). Our endpoints are stored
  // with a leading slash, so normalize to a relative path.
  if (typeof config.url === "string" && config.url.startsWith("/")) {
    config.url = config.url.replace(/^\/+/, "");
  }

  const currentUser = auth.currentUser;
  if (currentUser) {
    const idToken = await currentUser.getIdToken();
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${idToken}`;
  }
  return config;
});
